import React from 'react'

const DownloadIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={30}
            height={30}
            fill="none"
            {...props}
        >
            <rect width={30} height={30} fill="#fff" rx={3} />
            <path
                stroke="#8790A4"
                d="M6.5 15.889v5.333c0 .472.224.924.622 1.257.399.334.94.521 1.503.521h12.75c.564 0 1.104-.187 1.503-.52.398-.334.622-.786.622-1.258V15.89M15 7v10.667m0 0-3.719-3.111M15 17.666l3.719-3.11"
            />
        </svg>
    )
}

export default DownloadIcon